export const namespacedPrefix = '[BRANCHES]';
